module.exports = __webpack_public_path__ + "fonts/DB-Heavent-Thin-v3.2.757e45b3.ttf";